module.exports = __webpack_public_path__ + "static/img/jigou-guangxi-top.8290a3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-guangxi-top.png
// module id = UR8P
// module chunks = 2